import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/redux/store';
import { actions as alertActions } from 'src/redux/data/alerts';
import { actions as gmActions } from 'src/redux/data/groupManager';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (_state: RootState) => ({});

const mapActionCreators = {
  createGMBaselineAlertThreshold: alertActions.createBaselineAlertThreshold,
  editGMBaselineAlertThreshold: alertActions.updateBaselineAlertThreshold,
  createSubtenantBaselineAlertThresholds:
    gmActions.createSubtenantBaselineAlertThresholds,
  editSubtenantBaselineAlertThresholds:
    gmActions.editSubtenantBaselineAlertThresholds,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
